export default {"src":"/_next/static/media/google.c43e43a7.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};